import React from "react";
import ReactQuill from "react-quill";
import minusIcon_spinner from "../../Assets/minusIcon_spinner.svg";
import plusIcon_spinner from "../../Assets/plusIcon_spinner.svg";

const SpinnerQuestion = ({
  id,
  question,
  module,
  questionIndex,
  openQuestion,
  setOpenQuestion,
  containerIndex,
}) => {
  return (
    <>
      <div className="singleQuestion_name_Container">
        {questionIndex + 1}.
        <ReactQuill
          modules={module}
          theme="snow"
          className={`custom ${openQuestion === question.id ? "focus" : ""}`}
          onFocus={() => setOpenQuestion(question.id)}
          onBlur={() => setOpenQuestion(null)}
          value={question.question}
        />
      </div>
      <div className="nameAns_container">
        <div
          className="Name"
          style={{
            display: "flex",
            justifyContent: "space-between",
            paddingRight: "0.6rem",
          }}
        >
          <img src={minusIcon_spinner} alt="minusIcon_spinner" />
          <p sty>{question.answer}</p>
          <img src={plusIcon_spinner} alt="plusIcon_spinner" />
        </div>
      </div>
    </>
  );
};

export default SpinnerQuestion;
